import { render } from "./EnrollForm.vue?vue&type=template&id=74cae5b4&scoped=true"
import script from "./EnrollForm.vue?vue&type=script&lang=js"
export * from "./EnrollForm.vue?vue&type=script&lang=js"

import "./EnrollForm.vue?vue&type=style&index=0&id=74cae5b4&lang=scss&scoped=true"
import "./EnrollForm.vue?vue&type=style&index=1&id=74cae5b4&lang=css"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cae5b4"]])

export default __exports__